import React, { useState, useMemo } from 'react';
import { mockSubscribers } from '../../data/mockData';
import type { Subscriber } from '../../types';
import { SearchIcon, TrendUpIcon, ExportIcon, MoreIcon } from '../icons';

// FIX: Updated the onChange prop type to accept a ChangeEvent to match the native input element's onChange handler.
const Checkbox: React.FC<{ checked: boolean; onChange: (e: React.ChangeEvent<HTMLInputElement>) => void; id: string }> = ({ checked, onChange, id }) => (
  <div className="flex items-center">
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="h-4 w-4 rounded border-gray-300 text-[#681628] focus:ring-[#681628]"
    />
  </div>
);

const Subscribers: React.FC = () => {
    const [selectedSubscriberIds, setSelectedSubscriberIds] = useState<number[]>([]);

    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setSelectedSubscriberIds(mockSubscribers.map(s => s.id));
        } else {
            setSelectedSubscriberIds([]);
        }
    };

    const handleSelectOne = (id: number) => {
        if (selectedSubscriberIds.includes(id)) {
            setSelectedSubscriberIds(prev => prev.filter(subId => subId !== id));
        } else {
            setSelectedSubscriberIds(prev => [...prev, id]);
        }
    };
    
    const allSelected = useMemo(() => selectedSubscriberIds.length === mockSubscribers.length && mockSubscribers.length > 0, [selectedSubscriberIds.length, mockSubscribers.length]);

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5">
                    <p className="text-sm text-gray-500">Subscribers</p>
                    <p className="text-2xl font-bold text-gray-800 mt-1">600</p>
                </div>
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 flex items-center justify-center">
                    <div className="flex items-center gap-2 text-sm font-medium text-green-600 bg-green-50 rounded-full px-3 py-1.5">
                        <TrendUpIcon className="w-4 h-4"/>
                        100 over the last 30 days
                    </div>
                </div>
            </div>
            
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                <div className="p-4 sm:p-5 flex justify-between items-center">
                    <div className="relative max-w-xs w-full">
                        <label htmlFor="search-input" className="sr-only">Search</label>
                        <input
                            type="text"
                            id="search-input"
                            placeholder="Search"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#681628] focus:border-transparent"
                        />
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <SearchIcon className="w-4 h-4 text-gray-400" />
                        </div>
                    </div>
                    <button className="flex items-center gap-2 text-sm font-semibold text-green-700 bg-green-50 border border-green-200 rounded-lg px-4 py-2 hover:bg-green-100 transition-colors ml-4">
                        Export
                        <ExportIcon className="w-4 h-4" />
                    </button>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="pl-6 py-3 text-left">
                                    <Checkbox
                                        id="select-all"
                                        checked={allSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Emails</th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Join Date</th>
                                <th scope="col" className="relative px-6 py-3">
                                    <span className="sr-only">Actions</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {mockSubscribers.map((subscriber: Subscriber) => (
                                <tr key={subscriber.id} className="hover:bg-gray-50">
                                    <td className="pl-6 py-4">
                                        <Checkbox
                                            id={`subscriber-${subscriber.id}`}
                                            checked={selectedSubscriberIds.includes(subscriber.id)}
                                            onChange={() => handleSelectOne(subscriber.id)}
                                        />
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{subscriber.email}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{subscriber.joinDate}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                        <button className="text-gray-500 hover:text-gray-800">
                                            <MoreIcon className="w-5 h-5"/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Subscribers;